export class ExternalUrlObject {


    constructor(public name: string, public value: string) {
    }


}